import type { PeerState } from '../lib/tauri/host';

export function peerStateLabel(state: PeerState): string {
  switch (state) {
    case 'connected':
      return 'Conectado';
    case 'disconnected':
      return 'Conexão instável';
    case 'failed':
      return 'Falha na conexão';
    case 'closed':
      return 'Encerrado';
    default:
      return 'Conectando...';
  }
}

export function peerStateTone(state: PeerState): 'success' | 'warning' | 'danger' {
  switch (state) {
    case 'connected':
      return 'success';
    case 'failed':
    case 'closed':
      return 'danger';
    default:
      return 'warning';
  }
}
